/**
 * Validates a zip/postcode wildcard pattern chip.
 *
 * A value is interpreted by the position of the `*` wildcard:
 *   78    -> exact match      (postcode is exactly 78)
 *   78*   -> starts with 78
 *   *78   -> ends with 78
 *   *78*  -> contains 78
 *
 * Rules enforced here (matching backend semantics):
 *   - Leading/trailing whitespace is ignored.
 *   - A value that is empty or consists only of `*` is rejected.
 *   - A `*` anywhere other than the very start or very end (e.g. 7*8) is rejected.
 *
 * @param {string} value
 * @returns {boolean} true when the pattern is valid and can be added as a chip.
 */
export function isValidZipPattern(value) {
  const v = (value || '').trim();
  if (!v) {
    return false;
  }
  // Reject values consisting only of asterisks (e.g. "*", "**").
  if (/^\*+$/.test(v)) {
    return false;
  }
  // Strip a single leading and/or trailing wildcard, then ensure no `*` remains
  // internally (catches "7*8", "**78", "78**", etc.).
  const core = v.replace(/^\*/, '').replace(/\*$/, '');
  return !core.includes('*');
}

export default isValidZipPattern;
